module.exports = __webpack_public_path__ + "img/icon-search.e2998859.svg";